import type { ProjectStatus } from "@zplanem/responses"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"

// Semantic status tokens (ZPL-345): success/warning/pending families from
// the design; ready_for_work rides the navy interactive family (no design
// counterpart for a "ready" state yet — revisit after ZPL-342 re-extraction).
const STATUS_CLASSES: Record<ProjectStatus, string> = {
	draft: "bg-muted/60 text-muted-foreground",
	ready_for_work: "bg-primary/10 text-primary dark:bg-ring/15 dark:text-ring",
	in_progress: "bg-warning-muted text-warning-muted-foreground",
	awaiting_acceptance: "bg-pending text-pending-foreground",
	accepted: "bg-success-muted text-success-muted-foreground",
}

/** The pill's per-status colour classes — shared with the status menu. */
export function statusBadgeClass(status: ProjectStatus): string {
	return STATUS_CLASSES[status]
}

export function ProjectStatusBadge({ status }: { status: ProjectStatus }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	return (
		<span
			className={`inline-flex items-center rounded-sm border border-current/25 px-2.5 py-0.5 text-xs font-medium ${STATUS_CLASSES[status]}`}
		>
			{t.projects.statuses[status]}
		</span>
	)
}
